module.exports = __webpack_public_path__ + "fonts/1b07663ab4410997f7adeea2bd7b04a0.txt";